// extracted by mini-css-extract-plugin
export default {"root":"PJqZKENa7UHpC5yrMf9I","sticky":"I7Vgvp8S1_unhj6IzKu6","placeHolderShimmer":"o29dEUKdIebctt70gTRR"};